/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {debugCNitoUrl} from '../../helpers';
import {mobileMediaQuery, notWebMediaQuery, useIsWeb} from '../../styles';
import SocialLinksContainer from './SocialLinksContainer';

const CartoonitoParentalHeader = () => {
    const {t} = useTranslation();
    useEffect(() => {
        handleWindowResize();

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, []);

    const [fixedSize, setFixedSize] = useState(false);

    const handleWindowResize = () => {
        const windowWidth = window.innerWidth;

        if (windowWidth >= 950) {
            setFixedSize(true);
        } else {
            setFixedSize(false);
        }
    };

    const isWeb = useIsWeb();

    return (
        <Container>
            <Content>
                <WrappedLink to={`/home${debugCNitoUrl()}`}>
                    <RoundButton>
                        <ImageBack
                            src={require('../../assets/ic_chevron_white.png')}
                            alt="back"
                        />
                    </RoundButton>

                    <BackText>{t('parentalPage.back')}</BackText>
                    <Logo
                        src={require('../../assets/cnito_logo_black.svg')}
                        alt="logo"
                    />
                </WrappedLink>
                {isWeb && <ParentalTitleView />}
                <SocialLinksContainer minWidth={fixedSize ? 282 : 'auto'} />
            </Content>
        </Container>
    );
};

const Container = styled.div`
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    flex: 1;
    background-color: white;
`;

const Content = styled.div`
    display: flex;
    width: 100%;
    max-width: 1376px;
    height: 80px;
    align-self: center;
    background-color: white;
    color: black;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;
    padding: 0px 32px 0px 32px;

    ${mobileMediaQuery} {
        padding: 0px 16px;
    }
`;

const BackText = styled.div`
    font-family: 'Rodger';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.07em;
    color: black;
    text-transform: uppercase;
    align-self: center;
    padding: 0px 12px 0px 16px;
    ${mobileMediaQuery} {
        font-size: 12px;
        padding: 0px 6px 0px 6px;
    }
`;

const RoundButton = styled.div`
    display: flex;
    background-color: black;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;

    ${mobileMediaQuery} {
        width: 22px;
        height: 22px;
    }
`;

const ImageBack = styled.img`
    transform: scaleX(-1);
    padding-left: 4px;
    width: 10px;
    height: 19px;
    ${mobileMediaQuery} {
        width: 7px;
        height: 12px;
    }
`;

const WrappedLink = styled(Link)`
    display: flex;
    flex-direction: row;
    color: transparent;
    align-items: center;
`;

const TitleText = styled.div`
    font-family: Rodger;
    font-style: normal;
    font-weight: 900;
    font-size: 30px;
    line-height: 21px;
    letter-spacing: 0.07em;
    margin-left: 10px;
    text-transform: uppercase;
    color: black;
    ${mobileMediaQuery} {
        font-size: 24px;
    }
`;

const HStack = styled.div`
    display: flex;
    flex-direction: row;
    align-self: center;
    align-items: center;
    ${notWebMediaQuery} {
        margin-bottom: 22px;
    }
`;

const Logo = styled.img`
    margin-top: 3px;
    ${mobileMediaQuery} {
        width: 110px;
    }
`;

const ParentImage = styled.img`
    ${mobileMediaQuery} {
        width: 24px;
    }
`;

export const ParentalTitleView = () => {
    const {t} = useTranslation();
    return (
        <HStack>
            <ParentImage
                src={require('../../assets/ic_parents.png')}
                alt="Parent"
            />
            <TitleText>{t('parentalPage.title')}</TitleText>
        </HStack>
    );
};

export default CartoonitoParentalHeader;
